/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.elements.mentions.team.member.50plus': 'Команда • более 50 участников',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Команда • более 50 участников, включая вас',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Команда • 1 участник} few {Команда • {0} участника} many {Команда • {0} участников} other {Команда • {0} участника}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Команда • 1 участник, включая вас} few {Команда • {0} участника, включая вас} many {Команда • {0} участников, включая вас} other {Команда • {0} участника, включая вас}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Требуется доступ к Confluence',
  'fabric.mention.error.defaultAction': 'Повторите попытку через несколько секунд.',
  'fabric.mention.error.defaultHeadline': 'Произошла ошибка',
  'fabric.mention.error.differentText': 'Попробуйте ввести другой текст.',
  'fabric.mention.error.loginAgain': 'Выйдите из системы, а затем войдите снова.',
  'fabric.mention.noAccess.label': 'Нет доступа',
  'fabric.mention.noAccess.warning': '{name} не получит уведомление, так как доступ для этого пользователя закрыт.',
  'fabric.mention.unknow.user.error': 'Неизвестный пользователь: {userId}'
};